import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { ReactComponent as Success } from "../../svgs/success.svg";

const RecallConfirmed = ({ open, onCancel }) => {
  return (
    <DiaglogBox width={400} onCancel={onCancel} open={open}>
      <div
        className="py-5"
        style={{
          background: "url('/images/green_wave_bg.svg')",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="w-16 h-16 bg-[#5CD100] rounded-full mx-auto flex justify-center items-center">
          <Success className="text-white w-[50px] h-[50px]" />
        </div>
      </div>
      <h3 className="text-center mt-[15.5px] text-xl px-11 font-bold">
        Transfer Request Canceled !
      </h3>

      <div className="pb-8">
        <Button
          color={"blue"}
          className={
            "w-[120px] mt-9 h-[40px] text-white text-sm font-bold mx-auto block"
          }
          varient={"primary"}
          onClick = {onCancel}
        >
          Go back
        </Button>
      </div>
    </DiaglogBox>
  );
};

export default RecallConfirmed;
